import React, { memo, useEffect, useRef } from 'react'
import { mountRootParcel, Parcel } from 'single-spa'

import { equals } from '@divvy-web/utils'

interface FederatedSingleSpaAppProps {
  loaderFn: () => Promise<object>
}

const FederatedSingleSpaApp = memo(({ loaderFn, ...customProps }: FederatedSingleSpaAppProps) => {
  const elementRef = useRef<HTMLDivElement | null>(null)
  const parcelRef = useRef<Parcel | null>(null)
  const customPropsRef = useRef(customProps)

  useEffect(() => {
    const mounted = parcelRef.current?.getStatus() === 'MOUNTED'

    if (mounted && !equals(customProps, customPropsRef.current)) {
      parcelRef.current?.update?.(customProps).then(() => {
        customPropsRef.current = customProps
      })
    }
  })

  useEffect(() => {
    const domElement = elementRef.current
    const mounting = parcelRef.current && parcelRef.current.getStatus() !== 'MOUNTED'
    if (!domElement || mounting) return

    //@ts-expect-error - the type appears to be wrong, but it works
    const parcel = mountRootParcel(loaderFn(), {
      domElement: elementRef.current,
      ...customPropsRef.current,
    })

    parcelRef.current = parcel
    return () => {
      if (parcel?.getStatus() === 'MOUNTED') parcel.unmount()
    }
  }, [loaderFn])

  return <div ref={elementRef} />
})

export default FederatedSingleSpaApp
